module.exports = __webpack_public_path__ + "static/media/cg.9a994144.svg";